import React, { useRef } from "react";
import PropTypes from "prop-types";
import TimeRecordModalContext from "./context/TimeRecordModalContext.jsx";
import { useInfiniteScroll } from "../Hooks/index.jsx";

export const TimeRecordModalContent = ({
  isLoadingMore,
  children,
  showLimitedAccess,
  handleFetchMore,
  paginationDate,
}) => {
  const ref = useRef();
  useInfiniteScroll(handleFetchMore, 500, ref);

  return (
    <div
      className="tw-text-theme-900 tw-bg-page-paper-main tw-rounded-md tw-shadow-primary tw-overflow-auto"
      ref={ref}
    >
      <TimeRecordModalContext.Provider
        value={{
          isLoadingMore,
          showLimitedAccess,
          paginationDate,
        }}
      >
        {children}
      </TimeRecordModalContext.Provider>
    </div>
  );
};

TimeRecordModalContent.propTypes = {
  handleFetchMore: PropTypes.func,
  isLoadingMore: PropTypes.bool,
  showLimitedAccess: PropTypes.bool,
  paginationDate: PropTypes.number,
  children: PropTypes.node,
};

TimeRecordModalContent.defaultProps = {
  handleFetchMore: () => {},
  isLoadingMore: false,
  showLimitedAccess: false,
};
